import { formatPrice } from "../scripts/helpers/formatPrice"

const DiscountDetail = ({originalPrice, discount}) => {
    const calc = originalPrice - discount;
    return (
        <div className="discount">
            <img
                src={`${window._env_.STATIC_HOST}/static/website/images/icon-discount.svg`}
                alt=""
            />

            <div>
                <p>Precio de lista: $ {formatPrice(originalPrice)}</p>
                <p>Precio incluye descuento de $ {formatPrice(calc)} por compra online.</p>
            </div>
        </div>
    );
};

export default DiscountDetail;
